import * as React from 'react';
import styled from 'styled-components';
import Switch, {SwitchProps} from 'components/Switch';
import {SlideDown} from 'react-slidedown';

export type CollapseContainerProps
  = Pick<SwitchProps,
  | 'label'
  | 'defaultChecked'
  | 'onChange'> & {
  children: React.ReactNode | React.ReactNodeArray;
};

export type Checked = boolean;

export const Header = styled.header`
  > * {
    padding: 20px;
  }
`;

/**
 * The component collapse child content by switch
 * @param {CollapseContainerProps} props
 * @constructor
 */
export default function CollapseContainer(
    props: CollapseContainerProps,
): React.ReactElement<CollapseContainerProps> {
  const [
    checked,
    setChecked,
  ] = React.useState<Checked>(props.defaultChecked || false);

  /**
   * The handle of switch change.
   * @param {React.ChangeEvent<HTMLInputElement>} event
   */
  function handleSwitchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setChecked(event.target.checked);
    props.onChange && props.onChange(event);
  }

  return (
    <div>
      <Header>
        <Switch
          label={props.label}
          checked={checked}
          onChange={handleSwitchChange}
        />
      </Header>
      <SlideDown closed={!checked} transitionOnAppear={false}>
        {props.children}
      </SlideDown>
    </div>
  );
}
